var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReseticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.577 4.163a.75.75 0 1 0 1.021 1.099L2.577 4.163Zm-.465 5.181a.75.75 0 1 0-1.489.183l1.489-.183Zm9.505-.588a4.77 4.77 0 0 1-4.77 4.77v1.5a6.27 6.27 0 0 0 6.27-6.27h-1.5Zm-4.77-4.771a4.77 4.77 0 0 1 4.77 4.77h1.5a6.27 6.27 0 0 0-6.27-6.27v1.5ZM3.598 5.262a4.751 4.751 0 0 1 3.249-1.277v-1.5c-1.65 0-3.151.638-4.27 1.678l1.021 1.099Zm3.249 8.265a4.772 4.772 0 0 1-4.735-4.183l-1.489.183c.38 3.1 3.021 5.5 6.224 5.5v-1.5Z",
    fill: "#303752"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57 6.669a.75.75 0 1 0 0-1.5v1.5Zm-4.195-.75h-.75c0 .414.336.75.75.75v-.75Zm.75-4.195a.75.75 0 1 0-1.5 0h1.5ZM6.57 5.169H2.375v1.5H6.57v-1.5Zm-3.445.75V1.724h-1.5v4.195h1.5Z",
    fill: "#303752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReseticon);
export default __webpack_public_path__ + "static/media/reseticon.2204edcd4697f8bef2b1f4a74974e208.svg";
export { ForwardRef as ReactComponent };